module.exports = __webpack_public_path__ + "img-newstream.9c153fede5bc8519835b99217d9737ab.hashedasset.svg";